import React, {useReducer} from "react";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import {Grid} from "@material-ui/core";
import userRegistrationService from "./userRegistrationService";
import InputField from "../../componentes/form-fields/InputField/InputField";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import GridButtonRow from "../../componentes/form-grids/GridButtonRow";
import {IconLabelSwitch} from "../../componentes/iconSwitch/IconLabelSwitch";
import {IconSwitch} from "../../componentes/iconSwitch/IconSwitch";
import {DefaultDatagrid} from "../../componentes/datagrid/DefaultDatagrid";
import {DefaultScreenAccordion} from "../../componentes/layouts/components/DefaultScreenAccordion";
import {DefaultAutocomplete} from "../../componentes/autocomplete/DefaultAutocomplete";
import changePasswordService from "../change-password/changePasswordService";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import DefaultButton from "../../componentes/button/DefaultButton";
import {ImageUploadCard} from "../../componentes/DragNDrop/ImageUploadCard";

const columnsUserRegistrations = (t) => [
    {field: "id", flex: 0.5, visible: false},
    {
        field: "username",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} name="user" />;
        },
    },
    {
        field: "roleDescription",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="role" />;
        },
        flex: 1
    },
    {
        field: "blocked",
        flex: 0.5,
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="blocked" />;
        },
        template: (props) => {
            return (
                <>
                    {props.blocked === 1 ? (
                        <IconSwitch name="unLock" />
                    ) : (
                        <IconSwitch name="lock" />
                    )}
                </>
            );
        },
    },
    {
        field: "status",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];


const UserControl = () => {
    const {t} = useTranslation();
    const {control} = useForm();
    const userId = sessionStorage.getItem("userId");

    function reducer(state, action) {
        switch (action.type) {
            case 'update':
                return {...state, ...action.data}
            case "clear":
                return initialUserRegistrationState
            case 'success':
                return {...state, success: true, error: false}
            case 'error':
                return {...state, success: false, error: true}
            case 'close_alert':
                return {...state, success: false, error: false, alertMessageUser: ""}
            case 'clearAlertMsg':
                return {...state, alertMessageUser: ""}
            default:
                return new Error();
        }
    }


    const initialUserRegistrationState = {
        id: 0,
        username: "",
        blocked: 0,
        role: 1,
        password: "",
        confirmPassword: "",
        newPassword: "",
        status: 1,
        loggedUserId: userId,
        photo: "",
        base64Image: "",
        userRegistrationRows: [],
        alertMessageUser: "",
        success: false,
        error: false
    };

    const [userRegistration, dispatch] = useReducer(reducer, initialUserRegistrationState);
    const {id, username, blocked, role, password, status, photo, base64Image, newPassword, confirmPassword, userRegistrationRows, alertMessageUser, success, error} = userRegistration

    const handleChangeUser = ({target: {name, value, files}}) => {
        name === "photo"
            ? handlePhotoUploadUser(files)
            : dispatch({type: 'update', data: {[name]: value}})
    };
    const handlePhotoUploadUser = (files) => {
        if (!files.length > 0) {
            return;
        }

        let reader = new FileReader();

        reader.readAsDataURL(files[0]);
        reader.onload = () => {
            let base64 = reader.result.replace("data:", "").replace(/^.+,/, "");
            dispatch({type: 'update', data: {base64Image: base64}})
        };
    };

    const handleSearchUser = () => {
        const {password, confirmPassword, ...data} = userRegistration;
        userRegistrationService
            .get(data)
            .then((response) => {
                dispatch({type: 'update', data: {userRegistrationRows: response.data}})
            })
            .catch((e) => dispatch({type: 'update', data: {userRegistrationRows: []}}));
    };
    const samePasswordsUser = () =>
        userRegistration.password === userRegistration.confirmPassword;

    const sameNewPasswordsUser = () =>
        userRegistration.newPassword === userRegistration.confirmPassword

    const sameCurrentPassword = () => {
        if (userRegistration.password === '') {
            return true
        } else if (userRegistration.password !== userRegistration.newPassword) {
            return true
        }
        return false
    }


    const canSaveUser = () =>
        userRegistration.username &&
        userRegistration.role !== 0 &&
        userRegistration.status !== 2;

    const saveUser = () => {
        dispatch({type: 'clearAlertMsg'})
        if (canSaveUser()) {
            const {password, confirmPassword, photo, ...data} = userRegistration;

            const formattedData = {
                ...data,
                newPassword: (userRegistration.newPassword != '' ? (userRegistration.newPassword) : ''),
                password: (userRegistration.password != '' ? (userRegistration.password) : ''),
                currentPassword: userRegistration.password,
                // photo: userRegistration.photo,
                role: userRegistration.role,
            };

            if (formattedData.id === 0) {
                if (samePasswordsUser()) {
                    userRegistrationService
                        .create(formattedData)
                        .then((response) => {
                            if (response.status === 200 && response.data.id > 0) {
                                dispatch({type: "success"})
                                handleSearchUser();
                            }
                        })
                        .catch((e) => dispatch({type: "error"}));
                } else {
                    dispatch({type: "update", data: {success: false, error: true, alertMessageUser: t("differentPasswords")}})
                }
            } else {
                if (sameCurrentPassword()) {
                    if (sameNewPasswordsUser()) {
                        userRegistrationService
                            .update(formattedData)
                            .then((response) => {
                                if (response.status === 200 && response.data.id > 0) {
                                    dispatch({type: "success"})
                                    handleSearchUser();
                                }
                            })
                            .catch((e) => dispatch({type: "error"}));
                    } else {
                        dispatch({type: "update", data: {success: false, error: true, alertMessageUser: t("currentPasswords")}})
                    }
                } else {
                    dispatch({type: "update", data: {success: false, error: true, alertMessageUser: t("differentPasswords")}})
                }

            }
        } else {
            dispatch({type: "update", data: {success: false, error: true, alertMessageUser: t("checkFields")}})
        }
    };
    const selectedUserRegistrationChanged = (data) => {
        dispatch({
            type: 'update', data: {
                loggedUserId: userId,
                role: data.role, id: data.id,
                username: data.username,
                role: data.role,
                status: data.status,
                base64Image: data.base64Image,
                blocked: data.blocked,
            }
        })
    };

    const releaseUser = () => {
        let {confirmNewPassword, ...data} = userRegistration;
        if (id !== 0) {
            data = {...data, id: id, newPassword: "xxxxxx"};
            changePasswordService
                .update(data)
                .then((response) => {
                    if (response.status === 200) {
                        dispatch({type: "success"})
                    }
                })
                .catch((e) => {
                    dispatch({type: "error"});
                });

        } else {
            dispatch({type: "error"});
        }
    };


    const handleReloadImg = () => {
        const {password, confirmPassword, ...data} = userRegistration;
        userRegistrationService
            .get(data)
            .then((response) => {
                if (response.status === 200) {
                    const rows = []
                    response.data.forEach(item => {
                        rows.push({
                            id: item?.id,
                            username: item?.username,
                            blocked: item?.blocked,
                            role: item?.role,
                            password: item?.password,
                            confirmPassword: item?.confirmPassword,
                            status: item?.status,
                            photo: item?.photo,
                            base64Image: item?.base64Image,
                        });
                    });
                    dispatch({type: 'update', data: {...rows[0], userRegistrationRows: rows}})
                }
            })
            .catch((e) => dispatch({type: 'update', data: {userRegistrationRows: []}}));

    }


    return (
        <>
            <DefaultScreenAccordion
                title={"userControl"}
                isRegister
                fields={
                    <GridItemContainer>
                        <CustomAlert
                            message={alertMessageUser}
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({type: 'close_alert'})}
                        />
                        <Grid item xs={id !== 0 ? 9 : 12}>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={<IconLabelSwitch name="user" />}
                                        name="username"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChangeUser}
                                        value={username}
                                        length={50}
                                        error={error && username === ""}
                                        disabled={id !== 0}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"blocked"}
                                        onChange={handleChangeUser}
                                        value={blocked}
                                        label={t("blocked")}
                                        defaultSize
                                        items={[
                                            {id: 0, name: t("no"), status: 1},
                                            {id: 1, name: t("yes"), status: 1},
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"role"}
                                        onChange={handleChangeUser}
                                        value={role}
                                        label={t("role")}
                                        defaultSize
                                        defaultValue={0}
                                        useApi
                                        endpoint='GetProfileListAutoComplete'
                                    />

                                </Grid>
                            </GridInputRow>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={<IconLabelSwitch name="password" />}
                                        name="password"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChangeUser}
                                        value={password}
                                        length={50}
                                        type="password"
                                        error={error && password === ""}
                                    />
                                </Grid>
                                {id !== 0 ? (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <InputField
                                            iconLabelSwitch={
                                                <IconLabelSwitch name="password" labelName="newPassword" />
                                            }
                                            name="newPassword"
                                            control={control}
                                            defaultValue=""
                                            onChange={handleChangeUser}
                                            value={newPassword}
                                            length={50}
                                            type="password"
                                            error={
                                                error &&
                                                (password !== newPassword || newPassword === "")
                                            }
                                        />
                                    </Grid>) : null}
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="password" labelName="confirmPassword" />
                                        }
                                        name="confirmPassword"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChangeUser}
                                        value={confirmPassword}
                                        length={50}
                                        type="password"
                                        error={
                                            error &&
                                            (newPassword !== confirmPassword || confirmPassword === "")
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChangeUser}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            {id: 0, name: t("canceled"), status: 1},
                                            {id: 1, name: t("active"), status: 1},
                                            {id: 2, name: t("all"), status: 1},
                                        ]}
                                    />
                                </Grid>
                            </GridInputRow>
                        </Grid>
                        {id !== 0 ? (
                            <Grid item xs={3}>
                                <ImageUploadCard
                                    id={id}
                                    userId={userId}
                                    uploadCallBack={() => {handleReloadImg()}}
                                    isRegister={true}
                                    iconBase64={base64Image}
                                    endPoint={"CustomFileUploaderUser"}
                                />

                            </Grid>
                        ) : null}
                        <GridButtonRow>
                            <SearchClearSaveRow
                                customGrid
                                onClickSearch={handleSearchUser}
                                onClickClear={() => dispatch({type: 'clear'})}
                                onClickSave={saveUser}
                            />

                            <Grid item>
                                <DefaultButton
                                    onClick={releaseUser}
                                    content={t("releaseUser")}
                                    className="secondaryButton"
                                />
                            </Grid>
                        </GridButtonRow>
                    </GridItemContainer>
                } />
            {(userRegistrationRows.length > 0) ? (
                <DefaultScreenAccordion
                    title="Grid"
                    fields={
                        <Grid item xs={12}>
                            <DefaultDatagrid
                                columns={columnsUserRegistrations(t)}
                                dataSource={userRegistrationRows}
                                cellSelected={(args, grid) =>
                                    selectedUserRegistrationChanged(args.data)
                                } />
                        </Grid>}
                />
            ) : null}
        </>
    );
};

export default UserControl;
